import { cn } from '@/lib/utils'
import type { HTMLAttributes } from 'react'

interface ShimmerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
}

export function Shimmer({ className, ...props }: ShimmerProps) {
  return (
    <div
      {...props}
      className={cn(
        'animate-pulse rounded-lg',
        'bg-muted dark:bg-muted/60', // Light mode gray, dark mode stays same
        className
      )}
    />
  )
}
